




























import Vue from 'vue';
import { defineComponent, ref, watch, Ref, onMounted } from '@vue/composition-api';
import { min, parse, format } from 'date-fns';
import { LabelValue } from '../../abstractions';

import mobiscroll from '../../mobiscroll/js/scroller.javascript';

const componentName = 'wok-mobile-picker-time';

export default defineComponent({
    name: componentName,

    props: {
        value: {
            type: String,
            default: '00:00'
        },
        delta: { // Used to defined the interval of minutes/hours to be re-computed at each change
            type: Number,
            default: 5
        },
        pickerLabel: {
            type: String,
            default: ''
        },
        cancelLabel: {
            type: String,
            default: 'Cancel'
        },
        confirmLabel: {
            type: String,
            default: 'Confirm'
        }
    },

    setup(props, context) {
        const scroller = ref() as Ref<HTMLDivElement>;

        function parseValue(value: string | null) {
            if (value) {
                var parts = value.split(':');
                return [parseInt(parts[0]), parseInt(parts[1])];
            }
            return [0, 0];
        }

        const hours = new Array<string>(), minutes = new Array<string>();

        for (let i = 0 ; i < 24 ; i++) {
            hours.push(i.toString().padStart(2, '0'));
        }
        for (let i = 0 ; i < 60 ; i += props.delta) {
            minutes.push(i.toString().padStart(2, '0'));
        }

        let lastSelectedValue = props.value;
        let scrollerInstance: any = null;

        onMounted(() => {
            scrollerInstance = (<any>mobiscroll).scroller(scroller.value, {
                display: 'inline',
                showLabel: false,
                wheels: [
                    [{
                        circular: false,
                        data: hours
                    }, {
                        circular: false,
                        data: minutes
                    }]
                ],
                formatValue: function (data: [number, number]) {
                    return data[0].toString().padStart(2, '0') + ':' + data[1].toString().padStart(2, '0');
                },
                parseValue: function (valueText: string) {
                    return parseValue(valueText);
                },
                onChange: (evt: { valueText: string }) => {
                    lastSelectedValue = evt.valueText;
                }
            });
            scrollerInstance.setVal(parseValue(props.value));
        });

        watch(() => props.value, (val) => {
            scrollerInstance?.setVal(parseValue(val));
        });

        const onConfirm = () => {
            context.emit('input', lastSelectedValue);
        }

        const onRequestHidePicker = () => {
            context.emit('hide-picker');
        }

        return {
            scroller,
            onConfirm,
            onRequestHidePicker
        }
    }
})
